<template>
  <div>
    <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="sourceData" row-key="index" :loading="loading" @change="handlePageChange">
      <template slot="serviceName" slot-scope="text, record">
        <a-dropdown :trigger="['contextmenu']">
          <a v-tc="{ name: '跳转至阿里云' }" class="custom-link" :href="aliYunLink(record)" target="_blank">{{ record.service_name }}</a>
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="copyServiceName(record)"><a-icon type="copy" /> 复制服务名称 </a-menu-item>
            <a-menu-item key="2" @click="copySvcAddress(record)"><a-icon type="copy" /> 复制SVC地址 </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
      <span slot="serviceType" slot-scope="text, record">
        <a-tag v-if="record.service_type" :color="record.service_type.color">{{ record.service_type.label }}</a-tag>
      </span>
      <span slot="version" slot-scope="text, record">
        {{ record.version || '--' }}
      </span>
      <span slot="replicas" slot-scope="text, record">
        <a-tag :color="record.ready_replicas === record.expected_replicas ? 'green' : 'red'"> {{ record.ready_replicas || 0 }}/{{ record.expected_replicas || 0 }} </a-tag>
      </span>
      <span slot="request" slot-scope="text, record"> CPU: {{ record.request_cpu || '--' }} 内存: {{ record.request_memory || '--' }}</span>
      <span slot="limit" slot-scope="text, record"> CPU: {{ record.limits_cpu || '--' }} 内存: {{ record.limits_memory || '--' }}</span>
    </a-table>
  </div>
</template>

<script>
import { serviceEnvironment } from '@/api/system/service';

const columns = [
  {
    width: 80,
    title: '服务ID',
    align: 'center',
    key: 'service_id',
    dataIndex: 'service_id'
  },
  {
    ellipsis: true,
    title: '服务名称',
    scopedSlots: { customRender: 'serviceName' }
  },
  {
    width: 200,
    ellipsis: true,
    title: '命名空间',
    key: 'namespace',
    dataIndex: 'namespace',
    customRender: text => {
      return text || '--';
    }
  },
  {
    width: 80,
    title: '服务类型',
    scopedSlots: { customRender: 'serviceType' }
  },
  {
    width: 140,
    ellipsis: true,
    title: '镜像版本',
    scopedSlots: { customRender: 'version' }
  },
  {
    width: 100,
    title: '容器组数量',
    scopedSlots: { customRender: 'replicas' }
  },
  {
    width: 180,
    ellipsis: true,
    title: '所需资源',
    scopedSlots: { customRender: 'request' }
  },
  {
    width: 180,
    ellipsis: true,
    title: '资源限制',
    scopedSlots: { customRender: 'limit' }
  }
];

export default {
  data() {
    return {
      columns,
      loading: false,
      sourceData: [],
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 20, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      projectId: parseInt(this.$route.params.project_id) || null,
      filterForm: {
        name: null,
        service_type: null
      }
    };
  },
  computed: {
    aliYunLink() {
      return record => {
        return `https://cs.console.aliyun.com/#/k8s/cluster/c7e3c5b420a7947c29333031446884cd0/v2/workload/deployment/detail/${record.namespace}/${record.deployment_name}/pods?type=deployment&clusterType=ManagedKubernetes&profile=Default&state=running&ns=${record.namespace}&region=cn-shanghai`;
      };
    }
  },
  methods: {
    onFilter(filter) {
      this.filterForm = filter;
      this.pagination.current = 1;
      this.getServiceEnvironment();
    },
    getServiceEnvironment() {
      this.loading = true;
      serviceEnvironment({
        ...this.filterForm,
        project_id: this.projectId,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.loading = false;
          this.sourceData = res.data.items.map((item, index) => ({ index, ...item }));
          this.pagination.total = res.data.total;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handlePageChange(pagination) {
      this.pagination = pagination;
      this.getServiceEnvironment();
    },

    async copyText(text) {
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
          this.$message.success('复制成功');
        } else {
          // 降级方案
          const textArea = document.createElement('textarea');
          textArea.value = text;
          textArea.style.position = 'fixed';
          textArea.style.top = '0';
          textArea.style.left = '0';
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          this.$message.success('复制成功');
        }
      } catch (err) {
        this.$message.error(`复制失败: ${err}`);
      }
    },

    copyServiceName(record) {
      this.copyText(record.service_name);
    },
    copySvcAddress(record) {
      this.copyText(`http://${record.service_name}-svc.${record.namespace}.svc`);
    }
  }
};
</script>
